module.exports = __webpack_public_path__ + "img/iconUserGreen.5a4325d6.svg";